export default __webpack_public_path__ + "static/media/Personal.56ad52fc.jpeg";